import { Icon } from "@iconify/react/dist/iconify.js";
import { useState, useEffect } from "react";
import { useCustomer } from "../../../contexts/CustomerContext";

import CallChart from "../../../components/insights/CallChart";

import DurationChart from "../../../components/insights/DurationChart";
import SuccessChart from "../../../components/insights/SuccessChart";
import UnsuccessfulChart from "../../../components/insights/UnsuccessfulChart";

import MessagesChart from "../../../components/insights/MessagesChart";

import SentimentChart from "../../../components/insights/SentimentChart";
import PeakHourChart from "../../../components/insights/PeakHoursChart";

const Insights = () => {
    const { getEffectiveCustomerId } = useCustomer();
    const currentClient = getEffectiveCustomerId();

    // Animation states
    const [animationStates, setAnimationStates] = useState({
        header: false,
        callSummary: false,
        performance: false,
        callHandling: false,
        customerInteraction: false
    });

    // Trigger staggered animations on component mount
    useEffect(() => {
        const timeouts = [];

        // Stagger the animations with delays
        timeouts.push(setTimeout(() => {
            setAnimationStates(prev => ({ ...prev, header: true }));
        }, 100));

        timeouts.push(setTimeout(() => {
            setAnimationStates(prev => ({ ...prev, callSummary: true }));
        }, 300));

        timeouts.push(setTimeout(() => {
            setAnimationStates(prev => ({ ...prev, performance: true }));
        }, 500));

        timeouts.push(setTimeout(() => {
            setAnimationStates(prev => ({ ...prev, callHandling: true }));
        }, 700));

        timeouts.push(setTimeout(() => {
            setAnimationStates(prev => ({ ...prev, customerInteraction: true }));
        }, 900));

        // Cleanup timeouts on unmount
        return () => {
            timeouts.forEach(timeout => clearTimeout(timeout));
        };
    }, []);

    return (
        <div className="responsive-page-layout scrollable">
            <div className={`insights-title flex flex-row justify-between items-center w-full z-10 transition-all duration-700 ease-out ${
                animationStates.header
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-4'
            }`}>
                <div className="header-textbox">
                    <Icon icon="proicons:graph" className="header-icon"></Icon>
                    Insights
                </div>
            </div>
            {/* Call Summary */}
            <div className={`home-insights w-full flex flex-col gap-4 transition-all duration-700 ease-out ${
                animationStates.callSummary
                    ? 'opacity-100 translate-y-0 scale-100'
                    : 'opacity-0 translate-y-4 scale-95'
            }`}>
                <div className="home-insights-title flex flex-row items-center justify-between w-full">
                    <div className="subheader-textbox">
                        {/* <Icon icon="system-uicons:graph-bar" className="text-secondary responsive-icon-sm"></Icon> */}
                        {currentClient === 'kronk' ? 'Chat Summary' : 'Call Summary'}
                    </div>
                </div>
                <div className="chart-insights-responsive">
                    <div className="chart-container-responsive">
                        <CallChart clientId={currentClient} />
                    </div>
                    {currentClient !== 'kronk' && (
                        <div className="chart-container-responsive">
                            <DurationChart />
                        </div>
                    )}
                </div>
            </div>
            {/* Performance */}
            <div className={`home-insights w-full flex flex-col gap-4 transition-all duration-700 ease-out ${
                animationStates.performance
                    ? 'opacity-100 translate-y-0 scale-100'
                    : 'opacity-0 translate-y-4 scale-95'
            }`}>
                <div className="home-insights-title flex flex-row items-center justify-between w-full">
                    <div className="subheader-textbox">
                        {/* <Icon icon="mdi:performance" className="text-secondary responsive-icon-sm"></Icon> */}
                        Performance
                    </div>
                </div>
                <div className="chart-insights-responsive">
                    <div className="chart-container-responsive">
                        <SuccessChart />
                    </div>
                    <div className="chart-container-responsive">
                        <MessagesChart clientId={currentClient} />
                    </div>
                </div>
            </div>
            {/* Customer Interaction */}
            <div className={`home-insights w-full flex flex-col gap-4 transition-all duration-700 ease-out ${
                animationStates.customerInteraction
                    ? 'opacity-100 translate-y-0 scale-100'
                    : 'opacity-0 translate-y-4 scale-95'
            }`}>
                <div className="home-insights-title flex flex-row items-center justify-between w-full">
                    <div className="subheader-textbox">
                        {/* <Icon icon="uil:analysis" className="text-secondary responsive-icon-sm"></Icon> */}
                        Customer Interaction
                    </div>
                </div>
                <div className="chart-insights-responsive">
                    {currentClient !== 'kronk' && (
                        <div className="chart-container-responsive">
                            <SentimentChart />
                        </div>
                    )}
                    {currentClient !== 'kronk' && (
                        <div className="chart-container-responsive">
                            <UnsuccessfulChart />
                        </div>
                    )}
                </div>
                <div className="chart-container-responsive">
                    <PeakHourChart />
                </div>
            </div>
        </div>
    );
};

export default Insights;